import React from 'react'
import { connect } from 'react-redux'
import MediaQuery from 'react-responsive'
import { setCurrentUser, setAuthToken, setUserId } from '../actions/auth'
import { clearAuthToken } from '../local-storage'
import { Link } from 'react-router-dom'
import './header-bar.css'

export class HeaderBar extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            responsiveHide: false
        }
        this.hideShow = this.hideShow.bind(this)
        this.resizeHideMenu = this.resizeHideMenu.bind(this)
    }

    componentDidMount() {
        window.addEventListener("resize", this.resizeHideMenu)
    }

    logOut() {
        this.props.dispatch(setUserId(null))
        this.props.dispatch(setCurrentUser(null))
        this.props.dispatch(setAuthToken(null))
        clearAuthToken()
    }

    resizeHideMenu() {
        if (window.innerWidth < 656) {
            this.setState({ 
                responsiveHide: true
            })
        }
        else {
            this.setState({ 
                responsiveHide: false
            })
        }
    }

    hideShow() {
        this.setState({
            responsiveHide: !this.state.responsiveHide
        })
    }

    render() {
        let userBar
        if (this.props.loggedIn) {
            userBar = (
                <div>
                    <MediaQuery maxWidth={ 655 }>
                            <div className={ this.state.responsiveHide ? 'menu-icon' : 'menu-icon change' } onClick={ this.hideShow }>
                                <div className='bar1'></div>
                                <div className='bar2'></div>
                                <div className='bar3'></div>
                            </div>
                        </MediaQuery>
                    <ul className={ this.state.responsiveHide ? 'hide' : '' }>
                        <li>
                            <Link to='/dashboard'>Home</Link>
                        </li>
                        <li>
                            <Link to='/submit'>Submit a Paper</Link>
                        </li>
                        <li>
                            <Link to='/explore'>Explore</Link>
                        </li>
                        <li>
                            <button className='logout' onClick={ () => this.logOut() }>Log out</button>
                        </li>
                    </ul>
                </div>
            )
        }

        return (
               <div className="header-bar row">
                   <div className='col-12'>
                       <h1 className='logo'><Link to='dashboard'>CheckMe</Link></h1>
                       { userBar }
                    </div>
               </div>
        )
    }
}

const mapStateToProps = state => ({
    loggedIn: state.auth.currentUser !== null
})

export default connect(mapStateToProps)(HeaderBar)



// WEBPACK FOOTER //
// ./src/components/header-bar.js